<template>
  <div v-if="org">
    <div class="tab__Item">
      <error-prompt class="error--Modal" :errors="errors"></error-prompt>
      <success-prompt :updated="updated" :message="prompt.success"></success-prompt>

      <div class="formSection" v-if="loading === false">
        <org-fields v-model="item" :org="item" :loading="loading" />

        <div class="formSection__Row--Group">
          <button @click="update('org')" class="button">Update organisation</button>
        </div>

        <div class="formSection__Row">
          <button @click="deleteOrg()" class="button--DeleteAccount">
            Delete this organisation
            <icon name="trash-alt" />
          </button>
        </div>
      </div>
    </div>
    <loader class="imageLoader" :loading="loading || updating" />
  </div>
</template>

<script>
import HTTP from '@/http-common.js'
import Loader from '@/components/partials/Loader.vue'
import UpdatePost from '@/components/mixins/UpdatePost.js'
import OrgFields from '@/components/editor/OrgFields.vue'
import SuccessPrompt from '@/components/editor/SuccessPrompt.vue'
import ErrorPrompt from '@/components/editor/ErrorPrompt.vue'

export default {
  name: 'Organisation',
  components: {
    Loader,
    OrgFields,
    SuccessPrompt,
    ErrorPrompt,
  },
  mixins: [UpdatePost],
  data() {
    return {
      prompt: {
        success: 'Success! Organisation updated.',
      },
      item: {
        full_name: '',
        abbreviation: '',
        address: '',
        email: '',
        region_id: null,
        country_id: null,
        contents: {
          thumbnail_urls: '',
        },
        l10n: [{ lang: 'en', foreword: '', description: '', contents: [] }],
        source: {
          twitter: '',
          facebook: '',
        },
        affiliate_of_id: '',
      },
      updating: false,
      updated: false,
      loading: false,
      org: null,
      errors: [],
    }
  },
  mounted() {
    // Load user and org data
    this.loading = true
    this.org = JSON.parse(JSON.stringify(this.$store.state.accounts.org))

    HTTP.get(`org/${this.$store.state.accounts.org.id}`)
      .then((response) => {
        this.loading = false

        // Remove fields that don't work
        const data = response.data
        delete data.status
        delete data.affiliate_of_id

        this.item = data
        if (this.item.l10n[0] === undefined)
          this.item.l10n.push({ lang: 'en', description: '', foreword: '', contents: [] })

        this.prompt.save = 'Save'
        this.prompt.success = 'Success! Organisation updated.'
      })
      .catch((e) => {
        console.log(e)
        this.loading = false
      })
  },
  methods: {
    deleteOrg() {
      if (
        confirm(
          `Are you sure you wish to delete this organisation and all users and data associated with it? Deleting an organisation requires review from one of our administrators and may take up to 48 hours.`
        )
      ) {
        this.loading = true

        HTTP.post(`org/${this.item.id}/request_deletion`).then(() => {
          this.updated = true
          this.loading = false
          this.prompt.success =
            'Success! Your request has been sent and is pending<br /> review by one of our administrators.'

          // Enable edit
          setTimeout(() => {
            this.updated = false
          }, 3000)
        })
      }
    },
    // Location
    setPlace(place) {
      this.item.address = place.formatted_address
      this.$set(this.item.contents, 'location', {
        latitude: place.geometry.location.lat(),
        longitude: place.geometry.location.lng(),
      })
    },
  },
}
</script>
